<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
  
      <div  class="container" >        
        
        <div v-if="(cks==null || cks.length==0) && !isLoading" class="title mt-2">暂无爬虫CK</div>
        <div  v-else class="mt-2"> 
           
                <table class="mt-1">
                <tr class="table_title">
                    <th>ID</th>
                   
                    <th>手机号</th>
                    <th>说明</th>
                   
                    <th>状态</th>
                
                    <th>操作</th>
                
                   
                   
                    <th v-if="role==1">删除</th>
                    <th v-if="role==1">复制ck</th>
                  
                </tr>
        
                <template v-for="(account,ac_index) in cks" :key="ac_index">
                  <tr>
                    <td >
                      <div>{{account.objectId}}</div>
                    </td>
                   
                    <td>{{account.phone}}</td>
                    <td>
                      {{ account.account }}
                      <span v-if="account.from_account_id!=undefined">有正在自动跑的AI号</span>
                    </td>
                   
                    
                    <td>  
                     
                  <div class="col invalidText">
                      <span v-if="account.valid==false">登录过期</span>  
                      <span v-else>
                        <span v-if="account.need_sleep==true">请求频繁，休息中</span>
                      </span>         
                     </div>
                    </td>
                    
                    <td>
                    <div class="d-flex justify-content-center">
                  
                        <router-link :to="`/admin/ck/${account.objectId}`"> <img class="operationIcon" src="../assets/icon-login.svg" alt="授权" title="授权"></router-link>
                     
                       
                    </div>
                    
                    </td>
                
                  
                    <td v-if="role==1">
                      <div class="backBtn" @click="deleteAccount(ac_index,account.objectId)">删除</div>
                    </td>
                    <td v-if="role==1">
                      <div class="backBtn" @click="copyAccount(ac_index,account.objectId)">复制</div>
                    </td>
                  
                </tr>
                </template>
        
                </table>
        
                <div class="full-width d-flex justify-content-end mt-2">
  <button @click="add_new=true" class="blueBtn">添加账号</button>
</div>
       


      </div>
        <div>
        </div>
      </div>

 
      

      <div v-if="add_new==true" class="d-flex justify-content-center mt-2">
        <Form @submit="save" :validation-schema="schema">
        <div>
                <div class="mt-1 textbox_label">
             手机号<span class="important">*</span>：</div>
             <div class="d-flex justify-content">
                  <Field type="text" name="phone_no" id="phone_no" 
                                 class="textBox" 
                                 v-model="phone_no"
                                 @blur='check_phone'
                                 placeholder="请输入CK对应的手机号" 
                 />
             </div>
             <div v-if="phone_existed" class="textbox textbox_label error-message">此手机号已经注册</div>
             <div><ErrorMessage name="region" class="textbox textbox_label error-message"/></div> 
             <div><ErrorMessage name="phone_no" class="textbox_label error-message"/></div> 
         </div>

         <div class="mt-1">

        <div class="textbox_label">
        小红书名：
        </div>

        <div>
        <Field 
        type="text" 
        name="account" 
        id="account"
        class="textBox" 
        v-model="account_info"
        placeholder="请输入该爬虫的账号名" 
        />
        </div>
        <div>
        <ErrorMessage name="account" class="textbox_label error-message"/>
        </div>
        </div>

        <div class="mt-1 mb-1 d-flex justify-content-between">
            
               <button class="blueBtn submitBtn mr-2">提交</button>

               <button @click="add_new=false" class="normalBtn">隐藏</button>
        </div>
      </Form>

      </div>
      <div>
 

</div>
  </template>
  
  <script>
  
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';

  import moment from 'moment';

  import { Form, Field,ErrorMessage } from 'vee-validate';
  import * as yup from 'yup';
  
  export default {
    data(){
      const schema = yup.object({
      // region:yup.number('请输入数字区号').required('请输入区号').default(86),
       phone_no: yup.string().required("请输入手机号码")
     });

      return {
        schema,
        add_new:false,
        isLoading:false,
       
        showPopup: false,
        selectedAccount:null,
        showContentPop:false,
        isValid: true,
        spinnerColor:"#262626",
        errors:'',
        phone_no:'',
        account_info:'',
       
        
        role:0,
        cks:null
        
      }
      
    },
   
    components: {
      GridLoader,
      Form,
     Field,
     ErrorMessage,

    },
    computed: {
    countDown() {
      return `${this.count}秒`
    },
    localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD');
         return beijingTime
         
       }
     },
    formatDate(){
      return (datetimeString) => {
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD');
         return beijingTime
         
       }
     }
  },
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
    },
  
    beforeUnmount(){
  
    },
  
    mounted(){
      var token=localStorage.getItem('sessionToken');
      this.role=localStorage.getItem('role');
  
       if(token==undefined || token==null ||token=='' || this.role==undefined|| this.role!=1)
       {
          this.$router.push('index')
          return
       }
      
       this.getCKs()
    
    },
    methods:{ 

    

     async getCKs(){
        try{
          const response = await axios.get(this.domain+'xhs/get_pachong_cks');
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            this.cks=data.cks
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
       
      },
   
     
    async deleteAccount(index,account_id){
      if (window.confirm("确定要删除吗?")) {

        this.isLoading=true
        try{
          const response = await axios.get(this.domain+'xhs/delete_pachong_cks?id='+account_id);
          var data=response.data
          if(data.status=='Suc')
          {
        
            this.cks.splice(index,1)
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      }

    },
    async copyAccount(index,account_id){
      if (window.confirm("确定要复制吗?")) {

        this.isLoading=true
        try{
          const response = await axios.get(this.domain+'xhs/copy_pachong_cks?id='+account_id);
          var data=response.data
          if(data.status=='Suc')
          {
        
            this.cks[index]['need_sleep']=false

            this.cks[index]['valid']=true
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      }

    },

    async save(values){
         try{
           this.isSubmit=true;
           
         
           const response = await axios.post(this.domain+'xhs/new_pachong_ck',{
             'phone':values.phone_no,
              'account':values.account
             });
 
           var data=response.data
           if(data.status=='Suc')
           {
              
             this.cks.push(data.ck)
               
             this.phone_no=''
             this.account_info=''
             
           }
           else
           {
             this.errors=data['msg']
               console.error(data)
           }
         }
         catch(error)
         {
           this.errors=error.msg;
             console.error(data)
         }
         finally
         {
           this.isSubmit=false;
         }
     },
      
    }

    
     
    
  };
  </script>
  <style scoped>
  
  .account_icon{
    width: 28px;
  height: 28px;
  border-radius: 28px;
  }
  
  .operationIcon{
    width:24px;
    height:24px;
    cursor:pointer
  }
  
  .textbox_label{
    align-self: stretch;
   color: #262626;
   font-family: "Alibaba PuHuiTi";
   font-size: 14px;
   font-style: normal;
   font-weight: 400;
   line-height: normal;
  }
  .textBox{
    width:300px;
  }
  
  .dropdown{
    width: 130px;
  }
  
  .submitBtn{
  
   width: 300px;
  }
  
  .error-message{
    color:red
  }
  </style>
  
  
  